import * as ko from "knockout"
import 'jquery';

export class SmoothHeightExtention {
	static Init() {
		ko.bindingHandlers.smoothHeight = {
			update: (element, valueAccessor) => {
				let options = valueAccessor();
				$(element).animate({ height: options.height() }, 300);
			}
		};
	}
}